import { Typography } from '@mui/material';
import * as S from './BreadCrumbs.styled';

type PropsType = {
  breadcrumbNameMap: { path: string; name: string }[];
};

export const BreadCrumbs = ({ breadcrumbNameMap }: PropsType) => {
  return (
    <S.StyledBreadCrumbs>
      {breadcrumbNameMap.map((v, i) => {
        const last = i === breadcrumbNameMap.length - 1;
        return last ? (
          <Typography
            variant='body1'
            data-testid='breadcrumb'
            color={(theme) => theme.palette.black.light}
            key={v.path}
          >
            {v.name}
          </Typography>
        ) : (
          <S.StyledLink data-testid='breadcrumb' to={v.path} key={v.path}>
            {v.name}
          </S.StyledLink>
        );
      })}
    </S.StyledBreadCrumbs>
  );
};
